export default "__VITE_ASSET__Cgj$LPZU__"